import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import de from "./de.json";
import en from "./en.json";
import es from "./es.json";

const resources = {
  de: { translation: de },
  en: { translation: en },
  es: { translation: es },
};

// Browser-sicherer Import des LanguageDetectors
let LanguageDetector;
if (typeof window !== "undefined") {
  LanguageDetector = require("i18next-browser-languagedetector").default;
}

// Initialisierung nur einmal (wichtig für Gatsby)
if (!i18n.isInitialized) {
  if (LanguageDetector) {
    i18n.use(LanguageDetector); // 👈 zuerst registrieren!
  }

  i18n
    .use(initReactI18next)
    .init({
      resources,
      lng: "de",
      fallbackLng: "de",
      interpolation: { escapeValue: false },
      detection: {
        order: ["localStorage", "navigator"],
        caches: ["localStorage"],
        lookupLocalStorage: "lang",
      },
    });
}

export default i18n;
